module.exports = __webpack_public_path__ + "img/indexBg.33a1f8e0.png";